import React from "react";

function InputSearch({placeholder, onChange = () => {}, width = 340, sizeIcon = 16, inputFontSize = 14}) {
  const inputRef = React.useRef(null);
  return (
    <div className="input-custom-search" style={{width}}>
      <i onClick={() => onChange(inputRef.current.value)} style={{ fontSize: sizeIcon}} class="fa-regular fa-magnifying-glass flip-icon"></i>
      <input
        ref={inputRef}
        type="text"
        style={{fontSize: inputFontSize, fontWeight: 400}}
        className="form-control"
        placeholder={placeholder}
        onChange={(e) => {
          e.preventDefault();
          onChange(e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />
    </div>
  );
}

export default InputSearch;
